import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import 'tailwindcss/tailwind.css'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import MyButton from './components/MyButton.vue'
import HeroIcon from './components/HeroIcon.vue'
import MyButton from './components/MyButton.vue'
import MyTable from './components/MyTable.vue'
import MyAlert from './components/MyAlert.vue'
import TableInput from './components/TableInput.vue'
import MyInput from './components/MyInput.vue'
import globalMethods from './global-methods'
import MyToast from './components/MyToast.vue'
import MySelect from './components/MySelect.vue'
import MySelectList from './components/MySelectList.vue'
import MyConfirm from './components/MyConfirm.vue'
import MyModal from './components/MyModal.vue'
import MyPanel from './components/MyPanel.vue'
import moment from 'moment'
import * as _ from 'lodash'
// import * as vueMoment from 'vue-moment'
const app = createApp(App)
app.component('hero-icon', HeroIcon)
app.component('my-button', MyButton)
app.component('my-table', MyTable)
app.component('my-alert', MyAlert)
app.component('table-input', TableInput)
app.component('my-input', MyInput)
app.component('my-toast', MyToast)
app.component('my-select', MySelect)
app.component('my-select-list', MySelectList)
app.component('my-confirm', MyConfirm)
app.component('my-modal', MyModal)
app.component('my-panel', MyPanel)
app.mixin({
  methods: { ...globalMethods, moment }
})
app.use(store)
app.use(router)
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL
axios.interceptors.request.use((request : any) => {
  const token = localStorage.getItem('token')
  if (token) {
    request.headers.Authorization = `Bearer ${token}`
  }
  return request
})
app.use(VueAxios, axios)
app.provide('axios', app.config.globalProperties.axios)
app.mount('#app')
